import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../../config/api";
import { Menu, Dropdown, Icon } from 'antd';
import axios from "axios";

const postUrlLogin  = API_URL + "widgets";

class ByDate extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            status_widget : "inactive",
            current_key_time : {},
            result_rows : [],
            totals_widgets : { reservations_ly_by_widget : 0, reservations_by_widget : 0 },
            select_time_interval : 'hide-panel',
            plan_interval_time : {
                key : 'MONTH',
                value : '$month'
            }
        }
        this.getDefaultValues = this.getDefaultValues.bind(this);
    }
    getDefaultValues(){
        return {
            status_widget: "inactive",
            current_key_time: {},
            result_rows: [],
            totals_widgets: { reservations_ly_by_widget: 0, reservations_by_widget: 0 },
            plan_interval_time : {
                key : 'MONTH',
                value : '$month'
            }
        };
    }
    activeWdg(type){
        this.props.activeWidget(type)
    }
    handleTimeFilter(filt, segments, key, key_string) {
        let $self = this;
        let current_key_time    = this.state.current_key_time;

        let not_exist = (current_key_time[filt] === undefined) ? true : false;
        if(not_exist === true){
            current_key_time[filt] = key
        }else if(not_exist === false){
            delete current_key_time[filt]
        }

        const status  =  (Object.keys(current_key_time).length > 0) ? "active" : "inactive";

        if(status === "inactive"){
            segments = null;
        }
        this.setState({
            current_key_time : current_key_time,
            status_widget : status
        }, function(){
            $self.props.setSegments(segments, key, current_key_time);
            //$self.props.activeFiltersMS(status);
        });
    }
    componentWillReceiveProps(props){
        if(props.statics['months'] !== undefined){
            let wdg = props.statics['months'];
            this.state.result_rows = Object.keys(wdg).map((filt, index) => {
                
                let cssStyle;

                if(wdg[filt].num_reservations !== 0){
                    if(props.layout._widgetSegment["major-segment-" + filt] !== undefined && props.layout._widgetSegment["major-segment-" + filt] !== null){
                        cssStyle = { height : (props.layout._widgetSegment["major-segment-" + filt].clientHeight) }
                    }else{
                        cssStyle = wdg[filt].cssStyle;
                    }

                    const props_row = {
                        key : `list-bydate-${index}`,
                        className : `datagrid-item ${wdg[filt].state} ${(index%2 ? "row-c" : "")}`,
                        style : wdg[filt].state === "active" ? cssStyle : {}
                    }
                    const props_row_child = {
                        style : wdg[filt].state === "active" ? cssStyle : {}
                    }
                    const props_title = {
                        className : "title day", 
                        children : wdg[filt].string_value
                    }
                    const props_btn_more = {
                        onClick : this.handleTimeFilter.bind(this, filt, wdg[filt].segments, wdg[filt].key_value, wdg[filt].string_value),
                        className : `filter-row ${wdg[filt].state}`
                    }
                    
                    
                    return (
                        <div {...props_row}>
                            <div {...props_row_child}>
                                <span {...props_title}/>
                                {/*<span {...props_btn_more} />*/ }
                            </div>
                        </div>
                    )
                }
            })
        }
    }

    setIntervalTimeView(interval){
        this.setState({
            plan_interval_time : interval,
            select_time_interval : "hide-panel"
        }, function(){

            let params = {
                reservations_module : {
                    plan_interval_time : this.state.plan_interval_time,
                    reach_interval_time : this.props.app.state.reservations_module.reach_interval_time
                }
            }
           this.props.layout.callMainRequest(params, false);
        })
    }

    render = () => {
        const menu = (
            <Menu>
                <Menu.Item key="0" onClick={this.setIntervalTimeView.bind(this, { key : 'MONTH', value : '$month' })}>MONTH</Menu.Item>
                <Menu.Item key="1" onClick={this.setIntervalTimeView.bind(this, { key : 'WEEK', value : '$week' } )}>WEEK</Menu.Item>
                <Menu.Item key="3" onClick={this.setIntervalTimeView.bind(this, { key : 'DAY', value : '$dayOfWeek' })}>DAY</Menu.Item>
            </Menu>
        );
        return(<div className={"datagrid-widget by-date-plan " + this.state.status_widget + " " + this.props.hidden_wdg_time}>
            <div className={"container-fluid "}>
                <div className="row header-widget">
                    <div className="col-md-12 options-widget">
                        {/* <Dropdown overlay={menu} trigger={['click']}>
                            <a className="ant-dropdown-link select-interval-period" href="#">
                                {this.state.plan_interval_time.key} <Icon type="down" />
                            </a>
                        </Dropdown> */}
                        <span style={{color : "#FFFFFF"}} children={'MONTH'} />
                    </div>
                </div>
                <div className="current-values">
                    <div className="row">
                        <div className="col-md-12 head-current">
                            <span children={this.props.current_year} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 datagrid-list">
                            {this.state.result_rows}
                            <div className={"datagrid-month totals"}>
                                <div>TOTAL</div>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
        </div>)
    }
};

export default ByDate;



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/Reserves/ByDate.js